module.exports = __webpack_public_path__ + "static/media/GACA.283437d3.svg";